import { Form, Formik } from "formik";
import React, { useState } from "react";
import { signupInitialValues, signupValidationSchema } from "./signupSchema";
import { useUploadMediaMutation } from "../../service/uploadApi";
import MyTextField from "./components/myTextField";
import FileField from "./components/fileField";
import CheckYourEmail from "./components/CheckYourEmail";
import { useNavigate } from "react-router-dom";
import { useSignupMutation } from "../../service/authApi";
import MyPasswordField from "./components/myPasswordField";
import PhoneField from "./components/phoneNumberInput";
import AddressSection from "../../components/formCommon/addressSection";
import Button from "../../components/button/button";
import PageHeader from "../../components/layout/pageHeader";
import SignupLayout from "./signupLayout";
import MyCheckboxField from "./components/myCheckboxField";
import TermsAndConditionLabel from "./components/termsAndConditionLabel";

type regError = {
  status: number;
  data: { responseCode: number; message: string };
};
export default function SignupData() {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [photoPath, setPhotoPath] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [addPhoto, { isLoading: isPhotoLoading }] = useUploadMediaMutation();
  const [photoError, setPhotoError] = useState("");
  const navigate = useNavigate();

  const [signup, { isLoading: signupLoading }] = useSignupMutation();

  async function uploadPhoto(
    e: React.ChangeEvent<HTMLInputElement>,
    fileType: string,
  ) {
    const file = e.currentTarget.files?.[0];
    setPhotoError("");
    if (file) {
      if (!["image/jpg", "image/jpeg", "image/png"].includes(file.type)) {
        setPhotoError("unsupported file type");
        return;
      } else if (file.size >= 3000010) {
        setPhotoError("The document size must be 3MB or less");
        return;
      }
      const formData = new FormData();
      formData.append("userAvatar", file);
      const response = await addPhoto(formData)
        .unwrap()
        .catch((err) => {
          setPhotoError("Error occurred while ploading, please try again");
        });
      const filepath = await response.data?.userAvatar;
      setPhotoPath(filepath);
    }
  }

  return (
    <>
      <CheckYourEmail isOpen={openConfirm} setIsOpen={setOpenConfirm} />
      <SignupLayout>
        <PageHeader
          title="Hi, Welcome to Hailing Trades!"
          subtitle="Join as a client"
        />
        <div className="flex flex-col min-w-full items-center justify-center">
          <Formik
            initialValues={signupInitialValues}
            validationSchema={signupValidationSchema}
            onSubmit={async (values, { setFieldError }) => {
              if (photoError) return;
              setErrorMsg("");
              // if (!photoPath) {
              //   setFieldError("photo", "Image is required");
              //   return;
              // }
              if (photoPath) {
                values.avatar = photoPath;
              }
              await signup(values)
                .unwrap()
                .then((res) => {
                  if (res.responseCode === 200) {
                    setOpenConfirm(true);
                    window.dataLayer?.push({
                      event: "signup-success-client",
                      method: "email",
                    });
                    setTimeout(() => {
                      navigate("/login");
                    }, 10000);
                  }
                })
                .catch((e: regError) => {
                  setErrorMsg(e.data.message);
                });
            }}
          >
            {({ values, setFieldValue }) => (
              <Form className="md:grid  md:grid-cols-2  w-full gap-8 xl:w-[1160px] lg:w-[890px]">
                <div className="fieldset flex flex-col">
                  <MyTextField
                    name="firstName"
                    id="first name"
                    type="text"
                    label="First Name"
                    placeholder="First Name"
                    required
                  />
                </div>
                <div className="fieldset flex flex-col">
                  <MyTextField
                    name="lastName"
                    id="lastName"
                    type="text"
                    label="Last Name"
                    placeholder="Last Name"
                    required
                  />
                </div>
                <div className="fieldset flex flex-col">
                  <PhoneField
                    name="contactNumber"
                    id="contactNumber"
                    label="Phone Number"
                    placeholder="Phone Number"
                    required
                  />
                </div>

                <div className="fieldset flex flex-col">
                  <MyTextField
                    name="email"
                    id="email"
                    label="Email"
                    placeholder="Email "
                    type="text"
                    required
                  />
                </div>
                <div className="fieldset flex flex-col">
                  <MyPasswordField
                    name="password"
                    id="password"
                    label="Password"
                    type="password"
                    placeholder=" "
                    required
                  />
                </div>
                <div className="fieldset flex flex-col">
                  <MyPasswordField
                    name="confirmPassword"
                    id="confirmPassword"
                    label="Retype Password"
                    placeholder=" "
                    type="password"
                    required
                  />
                </div>
                <div className="fieldset flex flex-col">
                  <FileField
                    name="photo"
                    id="photo"
                    label="Upload Your Photo"
                    placeholder=" "
                    type="file"
                    fileType="photo"
                    onChange={uploadPhoto}
                  />
                  {isPhotoLoading && (
                    <div className="text-gray-500 mt-3">Uploading...</div>
                  )}
                  <div className="text-red-500 mt-3">{photoError}</div>
                </div>
                <AddressSection />
                <MyCheckboxField
                  name="termsAndConditions"
                  id="termsAndConditions"
                  label={<TermsAndConditionLabel />}
                  className="col-span-2"
                />
                <div className="flex justify-center col-span-2">
                  <Button
                    size="medium"
                    variant="primary"
                    type="submit"
                    disabled={signupLoading}
                    isLoading={signupLoading}
                  >
                    Create Account
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
          {errorMsg && (
            <div className="p-4 mb-4 text-sm text-red-700 mt-4 rounded-lg">
              {errorMsg}
            </div>
          )}
        </div>
      </SignupLayout>
    </>
  );
}
